import React, { Component } from 'react';
import Banner from '../../components/Banner'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Link from 'react-router-dom/Link'
// import Button from 'react-bootstrap/Button'
import { URL } from '../../components/BackendApi';
import './style.scss';

class OpenJobsPage extends Component {

  constructor(props){
    super(props)

    this.state = {
      jobs: [],
      openJobs: {},
      loading: true,
      error: null
    };

    this.openJob = this.openJob.bind(this);
  }

  componentDidMount() {
    this.fetchJobs();
  }
  
  fetchJobs() {
    this.setState({ loading: true });
    
    fetch(`${URL}/open_jobs/public`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        this.setState({
          jobs: data,
          loading: false,
          error: null
        });
      })
      .catch(error => {
        console.error('Error fetching jobs:', error);
        this.setState({
          error: 'Failed to load jobs. Please try again later.',
          loading: false
        });
      });
  }
  
  openJob(id) {
    this.setState(prevState => ({
      openJobs: {
        ...prevState.openJobs,
        [id]: !prevState.openJobs[id]
      }
    }));
  }

  render() {
    const { jobs, loading, error } = this.state;
    
    return (
      <div className="page employeepage">

        <Banner>
          <h1>Avoimet työpaikat</h1>
        </Banner>

        <Container id="content" className="intro p-t-50 p-b-50 text-center">
            <Row>
                <Col sm={{ span: 8, offset: 2}}>
                    <h2>Työnhakijalle</h2>
                </Col>
            </Row>             
        </Container>

        <Container className="p-b-50">
          {loading ? (
            <div className="text-center">Ladataan työpaikkoja...</div>
          ) : error ? (
            <div className="text-center text-danger">{error}</div>
          ) : jobs.length === 0 ? (
            <div className="text-center">Ei avoimia työpaikkoja tällä hetkellä.</div>
          ) : (
            jobs.map(job => (
              <a key={job.id} className="job" href={`/tyonhakijalle/tyo/${job.id}`}>
                <div className="job-aside">
                  <h2>{job.city}</h2>
                  {job.image == null ? '' : <img src={job.image} alt="" />}
                </div>

                <div className="job-text">
                  <h2>{job.city}<span class="mob">&nbsp;&nbsp;|&nbsp;&nbsp;</span>{job.quantity}</h2>
                  {job.work_location == null ? '' : <div class="extra">{job.work_location}</div>}
                  <div class="extra">{job.title}</div>
                  {job.salary == null ? '' : <div class="extra">{job.salary}</div>}

                  <div className="job-summary">
                    {String(job.summary || '').split(/\n\n+/).filter(Boolean).map((paragraph, i) => (
                      <p key={i}>{paragraph}</p>
                    ))}
                  </div>
                  <Link to={`/tyonhakijalle/tyo/${job.id}`} className="btn-blue">Lue lisää ja hae</Link>
                </div>
              </a>
            ))
          )}
        </Container>
      </div>
    );
  }
}

export default OpenJobsPage;
